import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePathname } from 'next/navigation';
import { cn } from '@/utils/cn';
import { contentsAPIV2 } from '@/utils/contentsApi';
import fetchJustForYou from '@/redux/thunk/just-for-you-thunk';
import { statusTypes } from '@/constants/types';
import DynamicSectionTitle from '../Typography/DynamicSectionTitle';
import JustForYouSlider from '../Slider/JustForYouSlider';

function JustForYouStaticCarousel({ section = null, isJustForYou = false }) {
  const pathname = usePathname();
  const dispatch = useDispatch();

  const { lang: selectLang } = useSelector((state) => state.globalSettings);
  const {
    items,
    isLoading: justForYouLoading,
    status,
  } = useSelector((state) => state.justForYou);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // trigger for dynamic content
  useEffect(() => {
    if (section && !isJustForYou) {
      setIsLoading(true);
      const fetchData = async () => {
        try {
          const contentsData = {
            sectionId: section?.id,
            contentType: section?.content_type,
          };
          const response = await contentsAPIV2(contentsData);
          setData([...response.items]);
          setIsLoading(false);
        } catch (err) {
          setIsLoading(false);
          console.warn('Error fetching for just for you static:', err);
        }
      };

      fetchData();
    }
  }, []);

  useEffect(() => {
    if (isJustForYou) {
      setIsLoading(justForYouLoading);

      if (items?.length === 0 && status === statusTypes.idle) {
        dispatch(fetchJustForYou());
      }

      setData([...items]);
      setIsLoading(justForYouLoading);
    }
  }, [isJustForYou, justForYouLoading, status]);

  if (!Array.isArray(data) || data?.length === 0) {
    return null;
  }

  return (
    <section
      className="just-for-you-static-carousel"
      role="presentation"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="container mx-auto">
        <DynamicSectionTitle
          text={section ? section?.title[selectLang] : 'Just For You'}
          className={cn({
            'text-center': pathname === '/',
          })}
        />
      </div>

      <JustForYouSlider items={data} isLoading={isLoading} />
    </section>
  );
}

export default JustForYouStaticCarousel;
